import {useState, useEffect} from 'react';
import {sleep} from "utils/sleep.js";
import CompressorEffect from "effects/Compressor.js";
import {setSelectedZObject} from 'actions/index.js';

export const useSynthz = (sequencerEngine) => {

    let [track, setTrack] = useState();
    let [oscilloscope, setOscilloscope] = useState(undefined);
    let [canvasBackground, setCanvasBackground] = useState(undefined);

    useEffect(() =>  {
        if (sequencerEngine) {
            let track = sequencerEngine.addMultiSynthTrack();
            track.setVolume(-4);
            track.setIsEnabled(true);
            setTrack(track);

            let fx = new CompressorEffect(sequencerEngine);
            fx.enable();
            fx.thresholdParameter.set(-9);
            sequencerEngine.channelMixer.masterChannel.effectsChain.addEffect(fx);

            sequencerEngine.currentSubSequence.createZObject(0,0, "system5");
            sequencerEngine.currentSubSequence.loadSubPatch("Oscilloscope Notes 2")
                .then(
                    osc => {
                        setOscilloscope(osc);
                    });

            /*
            sequencerEngine.currentSubSequence.loadSubPatch("Falling-Notes-Purple")
                .then(
                   async x => {
                       let canvases = sequencerEngine.currentSubSequence.findNodeByName("three.canvas");
                       let canvas = canvases[1];
                       while (!canvas) {
                           await  sleep(100);
                           canvases = sequencerEngine.currentSubSequence.findNodeByName("three.canvas");
                           canvas = canvases[1];
                       }
                       x.setAttribute('backgroundColor', '#000000');
                       x.setAttribute('color1', '#e600ff');
                       canvas.width = window.innerWidth;
                       canvas.height = window.innerHeight;
                       canvas.effect.sendMessage("size", [
                           canvas.width, canvas.height]);
                       setCanvasBackground(canvas);
                    });
                    */
           
        }
    }, [sequencerEngine, setTrack, setOscilloscope, setCanvasBackground]);

    useEffect(() => {
        if (canvasBackground) {
            canvasBackground.width = 314;
            canvasBackground.height = 153;
            canvasBackground.effect.sendMessage("size", [
                canvasBackground.width, canvasBackground.height]);
            sequencerEngine.dispatch(setSelectedZObject(track));
        }
    }, [canvasBackground]);

    return {track, oscilloscope, canvasBackground};
};
